import { create } from 'zustand';

interface UIStore {
  showCustomizeBackButton: boolean;
  setShowCustomizeBackButton: (value: boolean) => void;
  isChanged: boolean;
  setIsChanged: (value: boolean) => void;
}

export const useUIStore = create<UIStore>((set) => ({
  showCustomizeBackButton: true,
  setShowCustomizeBackButton: (value) => {
    set({ showCustomizeBackButton: value });
  },
  isChanged: false,
  setIsChanged: (value) => {
    set({ isChanged: value });
  },
}));
